import { merge } from 'lodash'
import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

export type State = {
  menuOpen: boolean
  swiperActive: boolean
  scrollLocked: boolean
  newsletterOpen: boolean
  scrollDirLocked: 'x' | 'y' | null
  needsAudioTrigger: boolean
}

export type Actions = {
  // eslint-disable-next-line no-unused-vars
  setState: (state?: Partial<State>) => void
}

const initialState: State = {
  menuOpen: false,
  scrollLocked: false,
  swiperActive: false,
  newsletterOpen: false,
  scrollDirLocked: null,
  needsAudioTrigger: false
}

const useLayoutStore = create(
  subscribeWithSelector(
    immer<State & Actions>((set) => ({
      ...initialState,
      setState: (state) => set((prevState) => merge(prevState, state))
    }))
  )
)

export { useLayoutStore }
